import { VerificationProcessStatus } from "./BEE123Enums";
import colors from "../../../assets/theme/base/colors";
const { primary, green, blue, lightTeal } = colors;

export enum VerificationProcessImages {
    TwoWomenChatting = 1,
    SilverLaptop = 2,
    StackOfPapers = 3,
    ManWorkingInFrontOfLaptop = 4,
    GroupOfPeopleInMeeting = 5,
    SilverMacBookAndNotepad = 6,
    AssortedPenAndPapers = 7,
    ManSigningPapers = 8,
    ManAndWomanWorkingTogether = 9,
    FinalReportIssued = 10,
    CertificateIssued = 11,
}

const verificationProcessImageFileNames: Record<VerificationProcessImages, string> = {
    [VerificationProcessImages.TwoWomenChatting]: "Two_women_chatting.jpg",
    [VerificationProcessImages.StackOfPapers]: "Stack_of_Papers.jpg",
    [VerificationProcessImages.SilverLaptop]: "Silver_Laptop.jpg",
    [VerificationProcessImages.ManWorkingInFrontOfLaptop]: "Man_working_in_front_of_a_laptop.jpg",
    [VerificationProcessImages.GroupOfPeopleInMeeting]: "Group_of_people_in_a_meeting_(boardroom).jpg",
    [VerificationProcessImages.SilverMacBookAndNotepad]: "Silver_MacBook_and_notepad.jpg",
    [VerificationProcessImages.AssortedPenAndPapers]: "Assorted_pen_and_papers.jpg",
    [VerificationProcessImages.ManSigningPapers]: "Man_signing_papers.jpg",
    [VerificationProcessImages.ManAndWomanWorkingTogether]: "Man_and_woman_working_together_at_a_desk.jpg",
    [VerificationProcessImages.FinalReportIssued]: "Final_report_issued.jpg",
    [VerificationProcessImages.CertificateIssued]: "Certificate_issued.jpg",
};

export function getVerificationProcessImage(id: VerificationProcessImages): string {
    return verificationProcessImageFileNames[id];
}

export const getVerificationStatusColour = (status: VerificationProcessStatus) => {
    switch (status) {
        case VerificationProcessStatus.Planned:
            return lightTeal.main;
        case VerificationProcessStatus["In Progress"]:
            return blue.main;
        case VerificationProcessStatus.Completed:
            return green.main;
        default:
            return primary.main;
    }
}